<template>
	<div class="p-y-16 bg-white d-flex border-bottom" @click="detail(transaksi)">
		<div class="p-r-12" v-if="transaksi.title === 'Transaksi'">
			<img v-if="transaksi.hapus === 0" src="../../../assets/icons/arrow-up-right-red.svg" alt="">
			<img v-else src="../../../assets/icons/plus-green.svg" alt="">
		</div>
		<div class="p-r-12" v-else>
			<img v-if="transaksi.hapus === 0" src="../../../assets/icons/plus-green.svg" alt="">
			<img v-else src="../../../assets/icons/arrow-up-right-red.svg" alt="">
		</div>
		<div class="d-flex-between-center align-items-start w-100">
			<div class="d-block">
				<div class="f-semi f-16 f-c-black">
					{{ transaksi.hapus === 1 ? 'Refund (' + transaksi.title + ')' : transaksi.title }}
					<img src="../../../assets/icons/chevron_right_4.svg"
					     v-if="transaksi.hapus === 0"
					     style="margin-top: -4px"
					     class="m-l-4"
					     alt=""
					/>
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					{{ transaksi.idtransaksi }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					{{ transaksi.waktu_transaksi_formated }}
				</div>
			</div>
			<div class="d-block text-right" v-if="transaksi.title === 'Transaksi'">
				<div class="f-semi f-16" :class="{'f-c-red': transaksi.hapus === 0, 'f-c-green' : transaksi.hapus === 1}">
					{{ transaksi.hapus === 0 ? "-" : "+" }} {{
						transaksi.kuota_transaksi.toString().split(".").length > 1 ?
							formatRupiah(transaksi.kuota_transaksi.toFixed(2)) :
							formatRupiah(transaksi.kuota_transaksi.toString())
					}} {{ transaksi.nama_satuan }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					Sisa {{ transaksi.kuota_akhir }} {{ transaksi.nama_satuan }}
				</div>
			</div>
			<div class="d-block text-right" v-else>
				<div class="f-semi f-16" :class="{'f-c-green': transaksi.hapus === 0, 'f-c-red' : transaksi.hapus === 1}">
					{{ transaksi.hapus === 0 ? "+" : "-" }} {{
						transaksi.kuota_transaksi.toString().split(".").length > 1 ?
							formatRupiah(transaksi.kuota_transaksi.toFixed(2)) :
							formatRupiah(transaksi.kuota_transaksi.toString())
					}} {{ transaksi.nama_satuan }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					Kuota menjadi {{ transaksi.kuota_akhir }} {{ transaksi.nama_satuan }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					Aktif {{
						transaksi.masa_aktif_formated === 'Selamanya' ? transaksi.masa_aktif_formated : 'hingga ' + transaksi.masa_aktif_formated
					}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardPaketDepositTransaksi",
	props: {
		transaksi: Object
	},
	methods: {
		detail(transaksi) {
			if (transaksi.hapus === 0) {
				this.$emit("detail", transaksi.title === 'Transaksi')
			}
		}
	}
}
</script>